import type React from 'react';

import { Link } from '@gitbook/react-uikit';
import { Alert } from '@gitbook/spine-react';

/**
 * SideSheet Panel informing the user about upgrading their Git sync installation.
 */
export function GitSyncLegacyUpgradeAlert({
    repository,
    startUpgrade,
}: {
    repository: string;
    startUpgrade: () => void;
}): React.ReactElement {
    const alertContent = (
        <div className="flex-1">
            <p>Your installation is based on an older version of Git sync.</p>
            <p className="mt-2">
                Your content is still synchronized with the {repository} Git repository, but we
                recommend that you{' '}
                <Link kind="in-text-muted" onPress={startUpgrade}>
                    upgrade to the new version
                </Link>{' '}
                to continue working in sync with GitHub.
            </p>
        </div>
    );

    return <Alert kind="info" size="small" title="Upgrade required" details={alertContent} />;
}
